import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
            o = it;
        var i = 0;
        var F = function F() { };
        return { s: F, n: function n() { if (i >= o.length)
                return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try {
        if (!normalCompletion && it.return != null)
            it.return();
    }
    finally {
        if (didErr)
            throw err;
    } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
import { curry } from "ramda";
import { syntaxTree } from "@codemirror/language";
import { StateEffect, StateField } from "@codemirror/state";
import { Decoration, EditorView } from "@codemirror/view";
var addBlinkSuccessMarks = StateEffect.define();
var removeBlinkSuccessMarks = StateEffect.define();
var blinkSuccessMarks = Decoration.mark({
    attributes: {
        class: "blink-eval"
    }
});
var addBlinkErrorMarks = StateEffect.define();
var removeBlinkErrorMarks = StateEffect.define();
var blinkErrorMarks = Decoration.mark({
    attributes: {
        class: "blink-eval-error"
    }
});
export var evalBlinkExtension = StateField.define({
    create: function create() {
        return Decoration.none;
    },
    update: function update(value, tr) {
        value = value.map(tr.changes);
        var _iterator = _createForOfIteratorHelper(tr.effects), _step;
        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var effect = _step.value;
                if (effect.is(addBlinkSuccessMarks)) {
                    value = value.update({
                        add: effect.value,
                        sort: true
                    });
                }
                if (effect.is(removeBlinkSuccessMarks)) {
                    value = value.update({
                        filter: effect.value
                    });
                }
                if (effect.is(addBlinkErrorMarks)) {
                    value = value.update({
                        add: effect.value,
                        sort: true
                    });
                }
                if (effect.is(removeBlinkErrorMarks)) {
                    value = value.update({
                        filter: effect.value
                    });
                }
            }
        }
        catch (err) {
            _iterator.e(err);
        }
        finally {
            _iterator.f();
        }
        return value;
    },
    // Indicate that this field provides a set of decorations
    provide: function provide(f) {
        return EditorView.decorations.from(f);
    }
});
var findSurroundingContext = function findSurroundingContext(view, tree) {
    var treeRoot = tree.node;
    var maybeContext = treeRoot;
    var lastContext = maybeContext;
    while (maybeContext) {
        if (["InstrumentDeclaration", "UdoDeclaration"].includes(maybeContext.type.name)) {
            return maybeContext;
        }
        // if we find ourselves in global scope, check if the user wanted to evaluate a global statement
        if (maybeContext.type.name === "Program" && ["OpcodeStatement", "CallbackExpression"].includes(lastContext.type.name)) {
            return lastContext;
        }
        lastContext = maybeContext;
        maybeContext = maybeContext.node.parent;
    }
};
var evalSelection = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(_ref) {
        var csound, documentType, evalString;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1)
                switch (_context.prev = _context.next) {
                    case 0:
                        csound = _ref.csound, documentType = _ref.documentType, evalString = _ref.evalString;
                        _context.t0 = documentType;
                        _context.next = _context.t0 === "orc" ? 4 : _context.t0 === "udo" ? 4 : _context.t0 === "sco" ? 7 : _context.t0 === "csd" ? 13 : 16;
                        break;
                    case 4:
                        _context.next = 6;
                        return csound.evalCode(evalString);
                    case 6:
                        return _context.abrupt("return", _context.sent);
                    case 7:
                        _context.next = 9;
                        return csound.readScore(evalString);
                    case 9:
                        _context.t1 = _context.sent;
                        if (_context.t1) {
                            _context.next = 12;
                            break;
                        }
                        _context.t1 = 0;
                    case 12:
                        return _context.abrupt("return", _context.t1);
                    case 13:
                        _context.next = 15;
                        return csound.evalCode(evalString);
                    case 15:
                        return _context.abrupt("return", _context.sent);
                    case 16:
                        console.error("document type isn't csound!");
                        return _context.abrupt("return", -1);
                    case 18:
                    case "end":
                        return _context.stop();
                }
        }, _callee);
    }));
    return function evalSelection(_x) {
        return _ref2.apply(this, arguments);
    };
}();
export var editorEvalCode = curry(function (csound, csoundStatus, documentType, view, blockEval) {
    if (csoundStatus !== "playing") {
        return;
    }
    var userHasSelection = view.state.selection.main.from !== view.state.selection.main.to;
    var selection;
    var context;
    if (userHasSelection && !blockEval) {
        selection = view.state.sliceDoc(view.state.selection.main.from, view.state.selection.main.to);
    }
    else if (blockEval) {
        var treeRoot = syntaxTree(view.state).cursorAt(view.state.selection.main.head);
        context = findSurroundingContext(view, treeRoot);
        if (_typeof(context) === "object" && typeof context.from === "number") {
            selection = view.state.sliceDoc(context.from, context.to);
        }
    }
    // fallback to current line if no selection
    if (!selection) {
        var line = view.state.doc.lineAt(view.state.selection.main.head);
        context = {
            from: line.from,
            to: line.to
        };
        selection = view.state.sliceDoc(line.from, line.to);
    }
    if (selection) {
        evalSelection({
            csound: csound,
            documentType: documentType,
            evalString: selection
        }).then(function (result) {
            if (result === 0) {
                view.dispatch({
                    effects: addBlinkSuccessMarks.of([blinkSuccessMarks.range(context.from, context.to)])
                });
            }
            else {
                view.dispatch({
                    effects: addBlinkErrorMarks.of([blinkErrorMarks.range(context.from, context.to)])
                });
            }
            setTimeout(function () {
                return result === 0 ? view.dispatch({
                    effects: removeBlinkSuccessMarks.of(function (from, to) {
                        return to <= context.from || from >= context.to;
                    })
                }) : view.dispatch({
                    effects: removeBlinkErrorMarks.of(function (from, to) {
                        return to <= context.from || from >= context.to;
                    })
                });
            }, 200);
        });
    }
});
export var uncommentLine = function uncommentLine(line) {
    var uncommentedLine = line.split(";");
    if (uncommentedLine.length > 1) {
        uncommentedLine = uncommentedLine[0];
    }
    else {
        uncommentedLine = uncommentedLine[0].split("//");
        uncommentedLine = uncommentedLine[0];
    }
    return uncommentedLine;
};
